import { POST } from '../../store-helper';
import { BASE_URL } from '../../../../config/environmentConfig';

export const forgotPassword = async ( username: string, formik?: any): Promise<any> => {
	return await POST({
    pathname: `${BASE_URL.IDENTITY}/identity/ForgotPassword`,
    body: { username },
    formik,
  });
};

export const confirmNewPassword = async (body: any): Promise<any> => {
	return await POST({
    pathname: `${BASE_URL.IDENTITY}/identity/ConfirmForgotPassword`,
    body,
  });
};
